import { useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router'
import { useAppData } from '../data'
import { canonicalBillPath } from '../discovery'
import { BillSearchResults, lookupResults } from '../components/search'

export function NotFoundPage() {
  const app = useAppData()
  const navigate = useNavigate()
  const [query, setQuery] = useState('')
  const [showResults, setShowResults] = useState(false)

  const searchResultsList = useMemo(() => {
    if (app.billsIndex.status !== 'ready') return []
    return lookupResults(app.billsIndex.data.bills, query, 6)
  }, [app.billsIndex, query])

  const onSelect = (boletin: string) => {
    setShowResults(false)
    setQuery('')
    navigate(canonicalBillPath(boletin))
  }

  return (
    <div className="not-found">
      <div className="not-found-inner">
        <h1 className="not-found-title">Página no encontrada</h1>
        <p className="not-found-message">La página que buscas no existe o fue movida. Prueba buscando un proyecto de ley:</p>
        <div className="not-found-search">
          <input
            type="text"
            placeholder="Buscar por boletín, título o tema…"
            value={query}
            onChange={(ev) => {
              setQuery(ev.target.value)
              setShowResults(true)
            }}
            onFocus={() => {
              app.triggerBillsIndex()
            }}
          />
          {showResults && searchResultsList.length > 0 && (
            <BillSearchResults
              results={searchResultsList}
              onSelect={onSelect}
              showDate={true}
              truncateTitleAt={80}
            />
          )}
        </div>
        <Link to="/" className="not-found-home">← Volver al inicio</Link>
      </div>
    </div>
  )
}
